import * as _ from 'lodash';
import * as React from 'react';
import * as Validator from 'validator';
import * as Model from '../../api/model';
import * as Request from '../../api/request';
import { WithStyles, Theme, TableRow, TableCell, Tooltip, IconButton, CircularProgress, Snackbar, FormControl, Input, FormHelperText } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import withStyles, { CSSProperties } from '@material-ui/core/styles/withStyles';
import { API } from '../../api';

//#region UI configuration
const strings = {
    saveButton: 'Save',
    cancelButton: 'Cancel',
    addError: 'Unable to add, try again',
    namePlaceholder: 'Enter name',
    nameIsRequired: 'Name is required',
};

const styles = (theme: Theme) => ({
    formControl: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center'
    } as CSSProperties,
    formField: {
        width: 300,
        marginRight: 8
    } as CSSProperties
});

type Styles = WithStyles<'formControl' | 'formField'>;
//#endregion

//#region Form configuration
const enum FormFieldNames {
    NAME = 'name'
}

interface FormFields {
    name: string;
}

interface FormErrors {
    name?: string;
}
//#endregion

//#region Props & State
interface AppellationAddItemProps {
    onItemAdded: (model: Model.Appellation) => void;
    onCancelItemAdd: () => void;
}
interface AppellationAddItemState {
    saving: boolean;
    error: null | string;
    fields: FormFields;
    errors: FormErrors;
}

type PropsWithStyles = AppellationAddItemProps & Styles;

const initialState: AppellationAddItemState = {
    saving: false,
    error: null,
    fields: {
        name: ''
    },
    errors: {}
};
//#endregion

class AppellationAddItem extends React.Component<PropsWithStyles, AppellationAddItemState> {

    private nameInput: HTMLInputElement;

    constructor(props: PropsWithStyles) {
        super(props);

        this.state = initialState;
    }

    render() {
        const { classes, onCancelItemAdd } = this.props;
        const { saving, error, errors, fields } = this.state;

        return (
            <React.Fragment>
                <TableRow selected={true}>
                    <TableCell numeric={true}>
                        {!saving && <React.Fragment>
                            <Tooltip title={strings.cancelButton}>
                                <IconButton onClick={onCancelItemAdd}>
                                    <CloseIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={strings.saveButton}>
                                <IconButton onClick={this.onSaveClick}>
                                    <SaveIcon />
                                </IconButton>
                            </Tooltip>
                        </React.Fragment>}
                        {saving && <CircularProgress size={45} />}
                    </TableCell>
                    <TableCell>
                        <FormControl margin="none" className={classes.formControl} error={!!errors.name}>
                            <Input
                                autoFocus={true}
                                className={classes.formField}
                                id={FormFieldNames.NAME}
                                inputRef={ref => this.nameInput = ref}
                                name={FormFieldNames.NAME}
                                placeholder={strings.namePlaceholder}
                                onChange={this.onFieldChange}
                                type="text"
                                value={fields.name}
                            />
                            <FormHelperText>{errors.name}</FormHelperText>
                        </FormControl>
                    </TableCell>
                    <TableCell />
                </TableRow>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={!!error}
                    autoHideDuration={6000}
                    onClose={this.onErrorClose}
                    message={<span>{error}</span>}
                    action={[
                        <IconButton
                            key="close"
                            color="inherit"
                            onClick={this.onErrorClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    ]}
                />
            </React.Fragment>
        );
    }

    private onErrorClose = () => {
        this.setState({ error: null });
    }

    private onFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            fields: { ...this.state.fields, [event.target.name]: event.target.value }
        });
    }

    private onSaveClick = () => {
        const errors: FormErrors = this.validateFormFields(this.state.fields);
        this.setState({ errors });

        if (_.isEmpty(errors)) {
            const { onItemAdded } = this.props;
            const { name } = this.state.fields;

            this.setState({ saving: true });

            API.appellation.add(new Request.Appellation(name))
                .then(model => {
                    onItemAdded(model);
                })
                .catch(() => {
                    this.setState({ saving: false, error: strings.addError });
                });
        } else if (!!errors.name) {
            this.nameInput.focus();
        }
    }

    private validateFormFields(fields: FormFields): FormErrors {
        const errors: FormErrors = {};

        if (Validator.isEmpty(fields.name)) {
            errors.name = strings.nameIsRequired;
        }

        return errors;
    }
}

export default withStyles(styles)<AppellationAddItemProps>(AppellationAddItem);



// WEBPACK FOOTER //
// ./src/modules/appellation/AppellationAddItem.tsx